module.exports = "/_next/static/images/847da36097053c9e0d3b60ef14ecedaf-roxinho-card-with-phone-md@1x.jpg.webp";